import { Loader } from '@carsys/ui'
import { RecentlyOpenedWorkorder } from '@cbgms/api'
import LicensePlate from '@cbgms/components/form/LicensePlate'
import React from 'react'
import { useTopSearchContext } from '../../../context/TopSearchContext'

interface VehicleSearchLineProps {
  workorder: RecentlyOpenedWorkorder
}

export const VehicleSearchLine: React.FC<VehicleSearchLineProps> = ({ workorder }) => {
  const { GetVehicleData } = useTopSearchContext()
  const vehicleData = GetVehicleData(workorder.VehicleUUID)
  if (vehicleData.isLoading) {
    return <Loader linear loading />
  }

  if (!vehicleData.data) {
    return null
  }
  return <LicensePlate style={{ verticalAlign: 'middle' }} registration={workorder.Registration} type={vehicleData?.data?.AssignedAs} />
}
